"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useForceRenderAtInterval;

var _react = require("react");

var _useTimer = _interopRequireDefault(require("./useTimer"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
} // The `nextTimer` function calculates the next absolute time that the timer should be fired based on the origin (original time received), interval, and current time.
// If the origin is t=260, and we are currently at t=1000, nextTimer must return t=60260.
// If the origin is t=260, and we are currently at t=60260 (exact landing), we must return t=120260, not t=60260.
// This is for fixing bug #2103: https://github.com/microsoft/BotFramework-WebChat/issues/2103.


function nextTimer(origin, interval) {
  var time = new Date(origin).getTime();
  var now = Date.now();
  return time > now ? time : now + interval - (now - time) % interval;
}

function useForceRenderAtInterval(origin, interval, fn) {
  var _useState = (0, _react.useState)(nextTimer(origin, interval)),
      _useState2 = _slicedToArray(_useState, 2),
      timer = _useState2[0],
      setTimer = _useState2[1];

  var handler = (0, _react.useCallback)(function () {
    fn && fn();
    setTimer(nextTimer(origin, interval));
  }, [fn, origin, interval]);
  (0, _useTimer.default)(timer, handler);
  return [timer, setTimer];
}